import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { ColorUtility } from '@jms/model';

@Component({
    selector: 'picker-item',
    templateUrl: './picker.item.component.html',
    styleUrls: ['./picker.item.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PickerItemComponent implements OnInit, OnChanges {

  @Input() text: string;
  @Input() color = 'transparent';
  @Input() colorEnabled = true;
  @Input() emptyText = 'Not Set';
  @Input() optionDesign = 'Text outside the box';

  public textColor = '#444';

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.textColor = ColorUtility.idealTextColor(this.color);
    }
  }
}
